import { AxiosResponse } from 'axios'
import { useApiClient } from './useApiClient'
import { ShardMetadata, ApiResult } from 'api'

export const useShardApi = () => {
  const apiClient = useApiClient()

  const getShards = () => {
    return apiClient.request<void, AxiosResponse<ApiResult<ShardMetadata[]>>>({
      url: `api/shards/metadata`,
      method: 'get',
      withCredentials: true,
    })
  }

  return {
    getShards,
  }
}
